import CloseIcon from '../icons/CloseIcon';
import { twMerge } from 'tailwind-merge';

export type TagProps = {
	label: string;
	onRemove?: () => void;
	disabled?: boolean;
	className?: string;
};

const Tag: React.FC<TagProps> = ({ label, onRemove, disabled, className }) => {
	return (
		<span
			className={twMerge(
				'bg-secondary-ultra-light flex items-center gap-2 px-2 py-1 rounded-full text-sm',
				className,
			)}
		>
			<span className='first-letter:uppercase inline-block'>{label}</span>
			{onRemove && (
				<button
					type='button'
					className={`p-0 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
					aria-label={`Remove ${label}`}
					onClick={(e) => {
						e.stopPropagation();
						onRemove?.();
					}}
					disabled={disabled}
				>
					<CloseIcon
						className='text-icon-cuaternary'
						height={12}
						width={12}
					/>
				</button>
			)}
		</span>
	);
};

export default Tag;
